import { BaseEntity } from '../../../models';

export class RegiaoGeograficaImediata implements BaseEntity {
    id: number;
    idRegiaoGeograficaIntermediaria: number;
    codigoIbge: number;
    nome: string;

    constructor(props: Partial<RegiaoGeograficaImediata>) {
        Object.assign(this, props);
    }
}
